import React from 'react';

import { Button } from '@grubhubprod/gh-cookbook-react';

export interface ZipGenerateStateButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  ariaLabel?: string;
}

export function ZipGenerateStateButton({
  onClick,
  isDisabled,
  ariaLabel,
}: ZipGenerateStateButtonProps): JSX.Element {
  return (
    <Button
      block
      aria-label={ariaLabel}
      disabled={isDisabled}
      variant="secondary"
      buttonSize="medium"
      onClick={onClick}
    >
      Download receipts
    </Button>
  );
}
